/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import PropTypes from "prop-types";
import { LiveBlogStoryTemplates } from "./templates";
import { StateProvider } from "../../../SharedContext";
import "./live-blog.m.css";

const LiveBlogStoryTemplate = ({ story = {}, config = {}, storyElementsConfig, children, adComponent, widgetComp }) => {
  const { theme = "", templateType = "default", verticalShare = "" } = config;
  const containerClass = templateType !== "hero-overlay" ? "container" : "";

  return (
    <div
      data-test-id={`live-blog-${templateType}`}
      className={`arrow-component arr--content-wrapper arr-story-grid arr--live-blog-story-template-wrapper ${templateType}`}
      style={{ backgroundColor: theme }}
      styleName={`${containerClass} ${verticalShare} wrapper`}
    >
      <LiveBlogStoryTemplates
        templateType={templateType}
        story={story}
        storyElementsConfig={storyElementsConfig}
        config={config}
        adComponent={adComponent}
        widgetComp={widgetComp}
      >
        {children}
      </LiveBlogStoryTemplates>
    </div>
  );
};

LiveBlogStoryTemplate.propTypes = {
  story: PropTypes.object,
  config: PropTypes.shape({
    templateType: PropTypes.string
  }),
  children: PropTypes.node,
  storyElementsConfig: PropTypes.object,
  adComponent: PropTypes.func,
  widgetComp: PropTypes.func
};

export default StateProvider(LiveBlogStoryTemplate);
